export const ResellerSubscriptionStatus = {
  CONTRACT: "CONTRACT",
  SETUP: "SETUP",
  INSPECTION: "INSPECTION",
  ACTIVE: "ACTIVE",
  SUSPENDED: "SUSPENDED",
  TERMINATED: "TERMINATED",
};

export const ResellerSubscriptionStatusLabel = {
  [ResellerSubscriptionStatus.CONTRACT]: "계약",
  [ResellerSubscriptionStatus.SETUP]: "세팅",
  [ResellerSubscriptionStatus.INSPECTION]: "검수",
  [ResellerSubscriptionStatus.ACTIVE]: "활성",
  [ResellerSubscriptionStatus.SUSPENDED]: "중단",
  [ResellerSubscriptionStatus.TERMINATED]: "종료",
};

export const ResellerSubscriptionStatusColor = {
  [ResellerSubscriptionStatus.CONTRACT]: "blue",
  [ResellerSubscriptionStatus.SETUP]: "cyan",
  [ResellerSubscriptionStatus.INSPECTION]: "purple",
  [ResellerSubscriptionStatus.ACTIVE]: "green",
  [ResellerSubscriptionStatus.SUSPENDED]: "orange",
  [ResellerSubscriptionStatus.TERMINATED]: "red",
};

export const PaymentCycle = {
  MONTHLY: "MONTHLY",
  YEARLY: "YEARLY",
  ONCE: "ONCE",
};

export const PaymentCycleLabel = {
  [PaymentCycle.MONTHLY]: "월간",
  [PaymentCycle.YEARLY]: "연간",
  [PaymentCycle.ONCE]: "1회성",
};

export const PaymentCycleColor = {
  [PaymentCycle.MONTHLY]: "green",
  [PaymentCycle.YEARLY]: "purple",
  [PaymentCycle.ONCE]: "cyan",
};

export const DiscountType = {
  PERCENTAGE: "PERCENTAGE",
  FIXED: "FIXED",
};

export const DiscountTypeLabel = {
  [DiscountType.PERCENTAGE]: "정률(%)",
  [DiscountType.FIXED]: "정액(원)",
};

export const PaymentStatus = {
  PENDING: "PENDING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  REFUNDED: "REFUNDED",
  PARTIAL_REFUNDED: "PARTIAL_REFUNDED",
  CANCELED: "CANCELED",
};

export const PaymentStatusLabel = {
  [PaymentStatus.PENDING]: "대기중",
  [PaymentStatus.COMPLETED]: "완료",
  [PaymentStatus.FAILED]: "실패",
  [PaymentStatus.REFUNDED]: "환불",
  [PaymentStatus.PARTIAL_REFUNDED]: "부분환불",
  [PaymentStatus.CANCELED]: "취소",
};

export const PaymentStatusColor = {
  [PaymentStatus.PENDING]: "blue",
  [PaymentStatus.COMPLETED]: "green",
  [PaymentStatus.FAILED]: "red",
  [PaymentStatus.REFUNDED]: "orange",
  [PaymentStatus.PARTIAL_REFUNDED]: "gold",
  [PaymentStatus.CANCELED]: "default",
};

export const SubscriptionPaymentStatus = {
  NORMAL: "NORMAL",
  OVERDUE: "OVERDUE",
};

export const SubscriptionPaymentStatusLabel = {
  [SubscriptionPaymentStatus.NORMAL]: "정상",
  [SubscriptionPaymentStatus.OVERDUE]: "미납",
};

export const SubscriptionPaymentStatusColor = {
  [SubscriptionPaymentStatus.NORMAL]: "green",
  [SubscriptionPaymentStatus.OVERDUE]: "red",
};
